<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 19:13:35
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-03 14:24:24
-->
<template>
  <div class="bottom-fixed-area">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'FixedBtnArea',
    props: {
      sidebar: {
        type: Boolean,
        default: true
      }
    },
    computed: {},
    watch: {
      sidebar: {
        handler() {
          this.setFixedWidth()
        },
        deep: true,
        immediate: true
      }
    },

    mounted() {
      this.setFixedWidth()
      const that = this
      window.onresize = () => {
        that.setFixedWidth() // 获取容器当前高度，重设表格的最大高度
      }
    },
    methods: {
      setFixedWidth() {
        setTimeout(() => {
          const width = document.querySelector('.app-main').offsetWidth
          console.log(width, 'width')
          document.querySelector('.bottom-fixed-area').style.width = `${width - 20}px`
        }, 300)
      }
    }
  }
</script>
<style lang="scss" scoped>
  // @import '../../../common/assets/style/variables';

  .bottom-fixed-area {
    position: fixed;
    z-index: 100;
    right: 10px;
    bottom: 10px;
    width: 100%;
    // margin-right: 40px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
  }
</style>
